// Footer da aplicação
/* global __DEV_SERVER_START__ */

import React from 'react';
import { useTranslation } from 'react-i18next';
import { BarChart3 } from 'lucide-react';
import { useAdmin } from '@/contexts/AdminContext';
import { VERSION_LABEL } from '@/config/version';

// Injetado pelo Vite (define) ao iniciar npm run dev ou npm run build
const devStartRaw = typeof __DEV_SERVER_START__ !== 'undefined' ? __DEV_SERVER_START__ : null;

function formatDevStart(iso) {
  if (!iso) return '';
  try {
    const d = new Date(iso);
    return d.toLocaleString('pt-BR', { dateStyle: 'short', timeStyle: 'short' });
  } catch {
    return iso;
  }
}

export default function Footer({ onOpenStats = null }) {
  const { t } = useTranslation();
  const { isCurrentUserAdmin } = useAdmin();
  const isLocal = typeof window !== 'undefined' && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' || window.location.hostname === 'pcpcryptotransfer.test');
  const showStatsLink = (import.meta.env.DEV || isLocal) && typeof onOpenStats === 'function' && isCurrentUserAdmin;

  return (
    <footer className="bg-gray-900 border-t border-purple-500 border-opacity-20 mt-12">
      <div className="max-w-7xl mx-auto px-4 py-8 text-center text-gray-400 text-sm">
        <p>{t('footer.copyright')}</p>
        <p className="mt-2">{t('footer.tagline')}</p>
        {showStatsLink && (
          <button
            type="button"
            onClick={onOpenStats}
            className="mt-3 inline-flex items-center gap-2 px-3 py-1.5 rounded-lg bg-purple-900/30 border border-purple-500/30 text-purple-300 hover:bg-purple-800/40 transition text-xs"
          >
            <BarChart3 size={14} />
            {t('footer.statsLink')}
          </button>
        )}
        <p className="mt-3 text-gray-500 font-mono text-xs" title={t('footer.versionTitle')}>
          v{VERSION_LABEL}
        </p>
        {import.meta.env.DEV && devStartRaw && (
          <p className="mt-1 text-gray-600 font-mono text-xs" title={t('footer.devStartedTitle')}>
            {t('footer.devStarted')} {formatDevStart(devStartRaw)}
          </p>
        )}
      </div>
    </footer>
  );
}
